import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing.space12,
    justifyContent: "space-between",
    borderRadius: theme.radius.small,
    background: theme.colors.background6,
    padding: theme.spacing.space8,
    paddingInlineEnd: theme.spacing.space12,
    "&.rank1": {
      border: `1px solid ${theme.colors.rankGolden}`,
      background: `linear-gradient(90deg, rgba(17, 22, 34, 0.00) 0%, #111622 100%), ${theme.colors.rankGolden}`,
    },
    "&.rank2": {
      border: `1px solid ${theme.colors.rankSilver}`,
      background: `linear-gradient(90deg, rgba(17, 22, 34, 0.00) 0%, #111622 100%), ${theme.colors.rankSilver}`,
    },
    "&.rank3": {
      border: `1px solid ${theme.colors.rankBronze}`,
      background: `linear-gradient(90deg, rgba(17, 22, 34, 0.00) 0%, #111622 100%), ${theme.colors.rankBronze}`,
    },
    "&.myRank": {
      border: `1px solid ${theme.colors.secondary}`,
      background: `linear-gradient(90deg, rgba(17, 22, 34, 0.00) 0%, #111622 100%), ${theme.colors.secondary}`,
    },
  },
  userContent: {
    overflow: "hidden",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing.space8,
    "&.myRank": {
      gap: theme.spacing.space20,
    },
  },
  rank: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing.space8,
  },
  reward: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing.space4,
    maxWidth: "40%",
  },
  content: {
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space4,
  },
  username: {
    overflow: "hidden",
    whitespace: "nowrap",
    textOverflow: "ellipsis",
  },
  giftData: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space4,
    borderRadius: theme.radius.medium,
    padding: `${theme.spacing.space2}px ${theme.spacing.space8}px`,
    background: theme.colors.rankOther,
    "&.rank1": { background: theme.colors.rankGolden },
    "&.rank2": { background: theme.colors.rankSilver },
    "&.rank3": { background: theme.colors.rankBronze },
    "&.myRank": { background: theme.colors.secondary },
  },
  directionUp: {
    color: "#4CAF50",
  },
  directionDown: {
    color: "#F44336",
  },
}));
